export const userInfo = {
  uid: "z04hqxFqpjbDQju6aDrS7Qq7FTK2",
  email: "jh_mcneill@yahoo.ca",
  username: "jhmcneill",
};
